import { Button } from '@pay-com/components'
import { CheckArrowFilled, Logo } from '@pay-com/icons'
import { useTranslation } from 'react-i18next'
import { TemporaryScreen } from '../types'

type OnboardingSubmittedProps = {
  setTemporaryScreen: (value: TemporaryScreen | null) => void
}

export const OnboardingSubmitted = ({
  setTemporaryScreen
}: OnboardingSubmittedProps) => {
  const { t } = useTranslation()

  return (
    <>
      <div className="fixed left-0 top-0 z-10 flex p-6">
        <Logo />
      </div>
      <div className="grid h-screen place-content-center">
        <div className="flex w-[29rem] flex-col items-center justify-center gap-4">
          <CheckArrowFilled
            className="size-20 text-green-500"
            fill="currentColor"
          />
          <h1 className="mt-6 text-2xl font-semibold text-blueGray-900">
            {t('applicationCompleted.title')}
          </h1>
          <p className="text-center text-base leading-7 text-gray-600 md:w-[27rem]">
            {t('applicationCompleted.thankYou')}
          </p>
          <p className="text-center text-base leading-7 text-gray-600 md:w-[27rem]">
            {t('applicationCompleted.reviewInfo')}
          </p>
          <Button
            className="mt-5 w-full md:w-[27rem]"
            type="button"
            onClick={() => setTemporaryScreen(null)}
          >
            {t('applicationCompleted.continueButton')}
          </Button>
        </div>
      </div>
    </>
  )
}
